import {IConfig} from "@/config/types";

const config: IConfig = {
  project: "gift-admin",
  httpPrefix: "/api",
  timeOut: 10 * 60 * 1000,
  platformName: "黄花梨种植管理及产品销售平台",
  company: "",
  uploadUrl: "/party/oss/ordinaryUpload",
  fragmentationUrl: "/party/oss/burstUpload",
  downloadUrl: "/api/party/oss/download",
  videoDownloadUrl:'/api/party/oss/play/video',
  versionName: "v1.0.0"
}

export default config
